import { PublicKey } from "@solana/web3.js";
import metadata from "../config/metadata.json"

export interface StakingConfig {
  enabled: boolean;  
  maxYield: number;
  minTermDays: number;
  maxTermDays: number;
  earlyUnstakePenalty: number; // in %
}

export interface TokenConfig {
    name:           string;
    symbol:         string;
    maxSupply:      number;
    decimals:       number;
    metadataUri:    string;
};

export interface ProgramConfig {
    
    canMint:        boolean;
    treasuryWallet: PublicKey;
    
    token: TokenConfig;
    
    rankDifficulty: {
        baseFee: number;
        scaleFactor: number[]
    },
    
    staking: StakingConfig
}

export const programConfig: ProgramConfig = {
    
    canMint:             true,
    treasuryWallet:     new PublicKey("3RbC4A66LP6AwAHYHr89BxFHBCdPpZg6eDBfRiokDeyK"),
    
    token: {
        name:           metadata.name,
        symbol:         metadata.symbol,
        maxSupply:      100_000_000_000_000_000,
        decimals:       1,
        metadataUri:    "https://arweave.net/tmWtR6356yN4-CgLe8mFpLD2wApcVzf1JIJ8eeTQ_LM"
    },
    
    rankDifficulty: {
        baseFee:     0.003, // base fee in sol
        scaleFactor: [3, 1], // 3 / 1 = 3.0
    },
    staking: {
        enabled:                true,
        maxYield:               100,    // in %
        minTermDays:            1,      // in days
        maxTermDays:            1095,   // days, 3yrs
        earlyUnstakePenalty:    25      // in %
    }
}
